<template>
  <div>
    <div v-if="editor" style="border-bottom:1px solid #ccc">
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }">
        <FormatBoldIcon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }">
        <FormatItalicIcon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleStrike().run()" :class="{ 'is-active': editor.isActive('strike') }">
        <FormatStrikethroughVariantIcon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleHighlight().run()" :class="{ 'is-active': editor.isActive('highlight') }">
        <MarkerIcon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().setParagraph().run()" :class="{ 'is-active': editor.isActive('paragraph') }">
        <FormatParagraphIcon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleHeading({ level: 1 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }">
        <FormatHeader1Icon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }">
        <FormatHeader2Icon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleHeading({ level: 3 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }">
        <FormatHeader3Icon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleHeading({ level: 4 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 4 }) }">
        <FormatHeader4Icon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleHeading({ level: 5 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 5 }) }">
        <FormatHeader5Icon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleHeading({ level: 6 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 6 }) }">
        <FormatHeader6Icon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleBulletList().run()" :class="{ 'is-active': editor.isActive('bulletList') }">
        <FormatListBulletedSquareIcon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleOrderedList().run()" :class="{ 'is-active': editor.isActive('orderedList') }">
        <FormatListNumberedIcon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().toggleBlockquote().run()" :class="{ 'is-active': editor.isActive('blockquote') }">
        <FormatQuoteCloseIcon />
      </button>
      <button class="btn btn-sm btn-light"  @click="editor.chain().focus().setHorizontalRule().run()">
        <MinusIcon />
      </button>
    </div>
    <editor-content  :editor="editor" />
  </div>
</template>

<script>
import StarterKit from '@tiptap/starter-kit'
import { Editor, EditorContent } from '@tiptap/vue-3'
import FormatListBulletedSquareIcon from 'vue-material-design-icons/FormatListBulletedSquare.vue'
import FormatListNumberedIcon from 'vue-material-design-icons/FormatListNumbered.vue'
import FormatBoldIcon from 'vue-material-design-icons/FormatBold.vue'
import FormatItalicIcon from 'vue-material-design-icons/FormatItalic.vue'
import FormatStrikethroughVariantIcon from 'vue-material-design-icons/FormatStrikethroughVariant.vue'
import MarkerIcon from 'vue-material-design-icons/Marker.vue'
import FormatHeader1Icon from 'vue-material-design-icons/FormatHeader1.vue'
import FormatHeader2Icon from 'vue-material-design-icons/FormatHeader2.vue'
import FormatHeader3Icon from 'vue-material-design-icons/FormatHeader3.vue'
import FormatHeader4Icon from 'vue-material-design-icons/FormatHeader4.vue'
import FormatHeader5Icon from 'vue-material-design-icons/FormatHeader5.vue'
import FormatHeader6Icon from 'vue-material-design-icons/FormatHeader6.vue'
import MinusIcon from 'vue-material-design-icons/Minus.vue'
import FormatParagraphIcon from 'vue-material-design-icons/FormatParagraph.vue'
import FormatQuoteCloseIcon from 'vue-material-design-icons/FormatQuoteClose.vue'
export default {
  components: {
    EditorContent,
    FormatListBulletedSquareIcon,
    FormatListNumberedIcon,
    FormatBoldIcon,
    FormatItalicIcon,
    FormatStrikethroughVariantIcon,
    MarkerIcon,
    FormatHeader1Icon,
    FormatHeader2Icon,
    FormatHeader3Icon,
    FormatHeader4Icon,
    FormatHeader5Icon,
    FormatHeader6Icon,
    MinusIcon,

    FormatParagraphIcon,
    FormatQuoteCloseIcon
  },

  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },

  emits: ['update:modelValue'],

  data() {
    return {
      editor: null,
    }
  },

  watch: {
    modelValue(value) {
      // HTML
      const isSame = this.editor.getHTML() === value

      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    },
  },

  mounted() {
    this.editor = new Editor({
      extensions: [
        StarterKit,
      ],
      content: this.modelValue,
      onUpdate: () => {
        // HTML
        this.$emit('update:modelValue', this.editor.getHTML())

        // JSON
        // this.$emit('update:modelValue', this.editor.getJSON())
      },
    })
  },
  beforeUnmount() {
    this.editor.destroy()
  },
}
</script>